<template>
  <PbBasicView no-min-height>
    <h1 class="pb-margin-bottom">
      {{ translate('pb2.requestView.title') }}
    </h1>
    <RouterView :name="routeViews.RequestForm" />
  </PbBasicView>
</template>

<script setup>
// import useHotkeys, { KEYS } from '@nicolaudie-group/ng-ui-kit/composables/useHotkeys'
// import * as sdk from '@/helpers/sdk'
// import useAction from '@/composables/useAction'
import PbBasicView from '@/components/PbBasicView.vue'
// import useProfileStore from '@/stores/profile.store'
import useTranslate from '@/composables/useTranslate'
// import { useDebounceFn } from '@vueuse/core'
import { RouterView } from 'vue-router'
import routeViews from '@/router/views'
// import TableCellSelect from '@nicolaudie-group/ng-ui-kit/components/Table/TableCellSelect.vue'

const { translate } = useTranslate()

</script>

<style lang="scss">
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '@nicolaudie-group/ng-ui-kit/components/UiField/field.mixin.scss';

@use '/src/styles/_pb.scss';
</style>
